import React, { FunctionComponent } from 'react'
import styles from './SideMark.module.sass'

interface Props {
    color?: string,
    width?: number,
}

const SideMark: FunctionComponent<Props> = props => <div
    className={styles.mark}
    style={{background: props.color, width: props.width ?? 4}}
/>

export default SideMark